
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/contacts",
      function () {
        return require("private-next-pages/android/contacts/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/contacts"])
      });
    }
  